import * as React from 'react';

import BoxSign32 from './BoxSign32';

export const boxSign32 = () => <BoxSign32 />;

export default {
    title: 'Icon/Logo/BoxSign32',
    component: BoxSign32,
    parameters: {
        notes: "`import BoxSign32 from 'box-ui-elements/es/icon/logo/BoxSign32';`",
    },
};
